<div class="container">
  @let brandingData = (brandingService.brandingData$ | async) || defaultBrandingSettings;
  @if (settings) {
    <div class="general-setting-section">
      <div class="slider-item">
        <mat-slide-toggle
          class="slider"
          [checked]="settings.enabled"
          (change)="toggleEnabled()"
          [style.--branding-color]="brandingData[BrandingField.FieldColorFontIconsListAreaItems]"></mat-slide-toggle>
        <div class="text">
          <span>{{ 'VOICE_MAIL_PREFERENCES.ENABLE_VOICEMAIL' | translate }}</span>
        </div>
      </div>
      <div class="slider-item">
        <mat-slide-toggle
          class="slider"
          [checked]="settings.announceReceivedTime"
          (change)="toggleAnnounceReceivedTime()"
          [style.--branding-color]="brandingData[BrandingField.FieldColorFontIconsListAreaItems]"></mat-slide-toggle>
        <div class="text">
          <span>{{ 'VOICE_MAIL_PREFERENCES.ANNOUNCE_VOICEMAIL_RECEIVED' | translate }}</span>
        </div>
      </div>
      <div class="slider-item">
        <mat-slide-toggle
          class="slider"
          [checked]="settings.announceIncomingCallId"
          (change)="toggleAnnounceIncomingCallId()"
          [style.--branding-color]="brandingData[BrandingField.FieldColorFontIconsListAreaItems]"></mat-slide-toggle>
        <div class="text">
          <span>{{ 'VOICE_MAIL_PREFERENCES.ANNOUNCE_INCOMING_CALL' | translate }}</span>
        </div>
      </div>
      <div class="slider-item">
        <mat-slide-toggle
          class="slider"
          [checked]="settings.confirmDeletion"
          (change)="toggleConfirmDeletion()"
          [style.--branding-color]="brandingData[BrandingField.FieldColorFontIconsListAreaItems]"></mat-slide-toggle>
        <div class="text">
          <span>{{ 'VOICE_MAIL_PREFERENCES.CONFIRM_VOICEMAIL_DELETION' | translate }}</span>
        </div>
      </div>
    </div>
    @if (!settings.residential) {
      <div class="section">
        <span class="sub-title d-block w-100">{{ 'VOICE_MAIL_PREFERENCES.OPERATOR_FORWARD' | translate }}</span>
        <div class="content">
          <mat-form-field
            appearance="outline"
            class="density-minus-3">
            <mat-label>{{ 'VOICE_MAIL_PREFERENCES.ENTER_OPERATOR_EXTENSION' | translate }}</mat-label>
            <input
              autocomplete="off"
              matInput
              [(ngModel)]="settings.operatorForward"
              (ngModelChange)="setSettingsChanged()" />
          </mat-form-field>
        </div>
      </div>
    }
    <div class="section">
      <span class="sub-title d-block w-100">{{ 'VOICE_MAIL_PREFERENCES.COPY_TO_EXTENSIONS' | translate }}</span>
      <div class="content flex align-items-center">
        <mat-form-field
          appearance="outline"
          class="density-minus-3">
          <mat-label>{{ 'VOICE_MAIL_PREFERENCES.ENTER_NAME_OR_EXTENSION' | translate }}</mat-label>
          <input
            [(ngModel)]="newExtension"
            (ngModelChange)="filterContacts()"
            [matAutocomplete]="auto"
            matInput />
          <mat-autocomplete #auto="matAutocomplete">
            <cdk-virtual-scroll-viewport
              [itemSize]="50"
              class="extensions-list">
              <mat-option
                *cdkVirtualFor="let contact of filteredContacts"
                [value]="contact.ext">
                <div class="extensions-item">
                  <app-name-coin [contact]="contact" />
                  <div class="ml-1">{{ contact.fullName }}</div>
                </div>
              </mat-option>
            </cdk-virtual-scroll-viewport>
          </mat-autocomplete>
        </mat-form-field>
        <button
          mat-icon-button
          color="primary"
          class="add-button"
          (click)="addNewExtension()"
          [disabled]="newExtension.length < 3"
          appBrandingColor
          [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
          styleType="color">
          <mat-icon>add_box</mat-icon>
        </button>
      </div>
      @for (extension of settings.copyToExtensions; track $index) {
        <div class="content flex align-items-center">
          <mat-form-field
            appearance="outline"
            floatLabel="auto"
            class="density-minus-3">
            <mat-label></mat-label>
            <input
              autocomplete="off"
              matInput
              readonly
              [ngModel]="extension" />
          </mat-form-field>
          <button
            mat-icon-button
            class="add-button"
            (click)="deleteExtension(extension)">
            <mat-icon class="delete-extension-button">close_box</mat-icon>
          </button>
        </div>
      }
    </div>
    <div class="section">
      <div class="sub-title flex space-between align-items-baseline">
        <span>{{ 'VOICE_MAIL_PREFERENCES.VOICEMAIL_GREETING' | translate }}</span>
        <button
          class="action-button"
          (click)="addNewGreetingClicked.emit()">
          <mat-icon
            color="primary"
            appBrandingColor
            [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
            styleType="color"
            >add</mat-icon
          >
          <span
            class="action"
            appBrandingColor
            [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
            styleType="color"
            >{{ 'VOICE_MAIL_PREFERENCES.ADD_NEW_GREETING' | translate }}</span
          >
        </button>
      </div>
      <div class="content">
        <div class="greeting-header">
          <div></div>
          <div>{{ 'VOICE_MAIL_PREFERENCES.NAME' | translate }}</div>
          <div>{{ 'VOICE_MAIL_PREFERENCES.DURATION' | translate }}</div>
          <div></div>
        </div>
        @if (greetings.length > 0) {
          <mat-radio-group
            [(ngModel)]="settings.selectedGreeting"
            (ngModelChange)="setSettingsChanged()">
            @for (greeting of greetings; track $index) {
              <div class="voicemail-greeting-player">
                <div class="w-20 flex align-items-center">
                  <mat-radio-button
                    color="primary"
                    [value]="greeting.index.toString()"
                    [style.--branding-color]="
                      brandingData[BrandingField.FieldColorFontIconsListAreaItems]
                    "></mat-radio-button>
                  <button
                    (click)="playClickHandler(greeting)"
                    class="play-pause"
                    color="primary"
                    mat-mini-fab>
                    <mat-icon
                      aria-hidden="true"
                      class="play-track">
                      {{ playingAudioId === greeting.index ? 'pause' : 'play_arrow' }}
                    </mat-icon>
                  </button>
                </div>
                <div class="w-40">{{ greeting.description }}</div>
                <div class="w-20">{{ Number(greeting.duration) | secondsToMinutes }}</div>
                <div class="w-20 actions">
                  <button
                    (click)="greetingDownloadClickHandler(greeting)"
                    color="primary"
                    mat-icon-button>
                    <mat-icon>download</mat-icon>
                  </button>
                  <button
                    (click)="handleClickOnDelete(greeting)"
                    color="primary"
                    mat-icon-button>
                    <mat-icon>delete_outline</mat-icon>
                  </button>
                  <button
                    (click)="handleClickOnEdit(greeting)"
                    color="primary"
                    mat-icon-button>
                    <mat-icon>edit_outline</mat-icon>
                  </button>
                </div>
              </div>
            }
          </mat-radio-group>
        } @else {
          <div class="voicemail-greeting-player disabled-player">
            <div class="w-20 flex align-items-center disabled-player-button-container">
              <button
                class="play-pause"
                disabled
                color="primary"
                mat-mini-fab>
                <mat-icon
                  aria-hidden="true"
                  class="play-track"
                  >play_arrow
                </mat-icon>
              </button>
            </div>
            <div class="w-40">{{ 'VOICE_MAIL_PREFERENCES.NOT_SET' | translate }}</div>
            <div class="w-40"></div>
          </div>
        }
      </div>
    </div>
    <div class="section">
      <div class="sub-title flex space-between align-items-baseline">
        <span>{{ 'VOICE_MAIL_PREFERENCES.RECORDED_NAME' | translate }}</span>
        <button
          class="action-button"
          (click)="handleClickOnManageRecording()">
          <span
            class="action"
            appBrandingColor
            [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
            styleType="color"
            >{{ 'VOICE_MAIL_PREFERENCES.MANAGE_RECORDED_NAME' | translate }}</span
          >
          <mat-icon
            color="primary"
            appBrandingColor
            [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
            styleType="color"
            >chevron_right</mat-icon
          >
        </button>
      </div>
      <div class="content">
        <div class="greeting-header">
          <div></div>
          <div>{{ 'VOICE_MAIL_PREFERENCES.NAME' | translate }}</div>
          <div></div>
          <div></div>
        </div>
        @if (settings.recordedNames && recordedName) {
          <div class="voicemail-greeting-player">
            <div class="w-20 recorded-button">
              <button
                (click)="playClickHandler(recordedName, true)"
                class="play-pause"
                color="primary"
                mat-mini-fab>
                <mat-icon
                  aria-hidden="true"
                  class="play-track"
                  >{{ playingAudioId === 'name' ? 'pause' : 'play_arrow' }}
                </mat-icon>
              </button>
            </div>

            <div class="w-40">{{ settings.recordedNames.name }}</div>
            <div class="w-20"></div>
            <div class="w-20 actions">
              <button
                (click)="greetingDownloadClickHandler(recordedName, true)"
                color="primary"
                mat-icon-button>
                <mat-icon>download</mat-icon>
              </button>
              <button
                (click)="handleClickOnDelete(recordedName, true)"
                color="primary"
                mat-icon-button>
                <mat-icon>delete_outline</mat-icon>
              </button>
              <button
                (click)="handleClickOnManageRecording()"
                color="primary"
                mat-icon-button>
                <mat-icon>edit_outline</mat-icon>
              </button>
            </div>
          </div>
        } @else {
          <div class="voicemail-greeting-player disabled-player">
            <div class="w-20 recorded-button disabled-player-button-container">
              <button
                disabled
                class="play-pause"
                color="primary"
                mat-mini-fab>
                <mat-icon
                  aria-hidden="true"
                  class="play-track"
                  >play_arrow
                </mat-icon>
              </button>
            </div>
            <div class="w-40">{{ 'VOICE_MAIL_PREFERENCES.NOT_SET' | translate }}</div>
            <div class="w-40"></div>
          </div>
        }
      </div>
    </div>
    @if (settings.unifiedMessaging) {
      <div class="section">
        <div class="sub-title flex space-between align-items-baseline">
          <span>{{ 'VOICE_MAIL_PREFERENCES.UNIFIED_MESSAGING' | translate }}</span>
        </div>
        <div class="content">
          <mat-form-field
            appearance="outline"
            class="select-dropdown density-minus-3">
            <mat-label>{{ 'VOICE_MAIL_PREFERENCES.EMAIL_NOTIFICATION' | translate }}</mat-label>
            <div class="flex">
              <mat-select
                [(value)]="settings.unifiedMessaging.emailNotification"
                (valueChange)="setSettingsChanged()">
                <mat-option value="no"> {{ 'VOICE_MAIL_PREFERENCES.NONE' | translate }}</mat-option>
                <mat-option value="notify_only">
                  {{ 'VOICE_MAIL_PREFERENCES.NOTIFICATION_ONLY' | translate }}</mat-option
                >
                @if (!configService.features[AppFeature.Hipaa]) {
                  <mat-option value="yes"> {{ 'VOICE_MAIL_PREFERENCES.SEND_HYPERLINK' | translate }}</mat-option>
                  <mat-option value="attnew">
                    {{ 'VOICE_MAIL_PREFERENCES.SEND_ATTACHMENT_NEW' | translate }}</mat-option
                  >
                  <mat-option value="attsave">
                    {{ 'VOICE_MAIL_PREFERENCES.SEND_ATTACHMENT_SAVED' | translate }}</mat-option
                  >
                  <mat-option value="atttrash">
                    {{ 'VOICE_MAIL_PREFERENCES.SEND_ATTACHMENT_TRASH' | translate }}</mat-option
                  >
                }
              </mat-select>
            </div>
          </mat-form-field>
          <mat-checkbox
            class="w-100"
            color="primary"
            [checked]="settings.unifiedMessaging.emailWhenMailBoxIsFull"
            (change)="toggleEmailWhenMailBoxIsFull()">
            {{ 'VOICE_MAIL_PREFERENCES.SEND_EMAIL_WHEN_FULL' | translate }}
          </mat-checkbox>
          <mat-checkbox
            class="w-100"
            color="primary"
            [checked]="settings.unifiedMessaging.emailOnMissCall"
            (change)="toggleEmailOnMissCall()">
            {{ 'VOICE_MAIL_PREFERENCES.SEND_EMAIL_AFTER_MISSED_CALL' | translate }}
          </mat-checkbox>
          <button
            class="action-button pin-button"
            (click)="setSelectedPage('Pin')">
            <span
              class="action"
              appBrandingColor
              [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
              styleType="color"
              >{{ 'VOICE_MAIL_PREFERENCES.CHANGE_VOICEMAIL_PIN' | translate }}</span
            >
            <mat-icon
              color="primary"
              appBrandingColor
              [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
              styleType="color"
              >chevron_right</mat-icon
            >
          </button>
          <br />
        </div>
      </div>
    } @else {
      <div class="section">
        <div class="content">
          <button
            class="action-button pin-button"
            (click)="setSelectedPage('Pin')">
            <span
              class="action"
              appBrandingColor
              [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
              styleType="color"
              >{{ 'VOICE_MAIL_PREFERENCES.CHANGE_VOICEMAIL_PIN' | translate }}</span
            >
            <mat-icon
              color="primary"
              appBrandingColor
              [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
              styleType="color"
              >chevron_right</mat-icon
            >
          </button>
          <br />
        </div>
      </div>
    }
  }
</div>
